<app-form-admindelegate
    [delegateList]="delegateList"
    [delegateBase]="delegateBase"
    (onValidate)="validate($event)"
    (onCancel)="cancel()"
>
</app-form-admindelegate>
